import { ref, watch } from 'vue'
import { defineStore } from 'pinia'
import type { IBridgeDeytail } from '@/apiFzn/types'
import { getBridgeDataDetail } from '@/apiFzn'

/**桥梁数据 */
export const useBridgeStore = defineStore('bridge', () => {
  // 状态
  const bridgeId = ref<number>()
  const showDetail = ref(false)
  const bridgeDetail = ref<IBridgeDeytail>()

  // 方法
  const openBridgeDetail = async (id: number) => {
    bridgeId.value = id
    showDetail.value = true
    await loadBridgeDetail()
  }

  const closeDetail = () => {
    showDetail.value = false
    bridgeId.value = undefined
    bridgeDetail.value = undefined
  }

  // 私有方法
  const loadBridgeDetail = async () => {
    if (!bridgeId.value) return
    try {
      const res = await getBridgeDataDetail({ id: bridgeId.value })
      bridgeDetail.value = res.data
    } catch (error) {
      console.error('获取桥梁详情失败:', error)
    }
  }

  return {
    // 状态
    bridgeId,
    showDetail,
    bridgeDetail,

    // 方法
    openBridgeDetail,
    closeDetail,
  }
})
